export default {
	string: (v) =>
		/^[a-z,A-Z][a-z,A-Z, ]*$/.test(v) ||
		"Este campo contiene caracteres invalidos.",

	email: (v) => /.+@.+\..+/.test(v) || "Este campo no es email.",

	required: (v) => {
		if (Array.isArray(v)) {
			if (v.length) {
				return true;
			}
		} else if (v !== null && v !== undefined) {
			return true;
		}

		return "Campo requerido.";
	},

	date: (v) =>
		/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(v) || "Este campo no es fecha.",

	alphanumeric: (v) =>
		/^[a-z,A-Z,0-9]*$/.test(v) || "Este campo no es alfanumerico.",

	integer: (v) => /^([1-9][0-9]*)*$/.test(v) || "Este campo no es entero.",

	double: (v) => /^\d+(\.\d{1,2})?$/.test(v) || "Este campo no es valido.",

	min10: (v) => (v && v.length >= 10) || "Mínimo 10 caracteres.",

	rfc: (v) =>
		/^([A-Z,Ñ,&]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])[A-Z|\d]{3})$/.test(v) ||
		"Este campo no es un RFC valido.",

	max5: (v) => (!!v && v.length <= 5) || "Maximo 5 caracteres.",
	max10: (v) => (!!v && v.length <= 10) || "Maximo 10 caracteres.",
	max15: (v) => (!!v && v.length <= 15) || "Maximo 15 caracteres.",
	max20: (v) => (!!v && v.length <= 20) || "Maximo 20 caracteres.",
	max25: (v) => (!!v && v.length <= 25) || "Maximo 25 caracteres.",
	max30: (v) => (!!v && v.length <= 30) || "Maximo 30 caracteres.",

	min: (type, min, value) => {
		if (value && min && type) {
			if (type === "date" || type === Date) {
				if (value < min) {
					return `La fecha debe ser mayor o igual a: ${min}.`;
				}
			}

			if (type === "integer" || type === "numeric" || type === Number) {
				if (value < min) {
					return `El número debe ser mayor o igual a: ${min}.`;
				}
			}

			if (type === 'text' || type === String) {
					if (value.length < min) {
						return `Mínimo ${min} caracteres.`;
					}
			}

			if (type === Array) {
				if (value.length < min) {
					return `Las posiciones para esta colección deben ser mayor a: ${min}.`
				}
			}
		}

		return true;
	},

	max: (type, max, value) => {
		if (value) {
			if (type === "date") {
				var max = new Date(max);
				var value = new Date(value);

				if (value >= max) {
					return true;
				}

				return `La fecha debe ser mayor o igual a: ${value}`;
			}

			if (type === "integer" || type === "numeric" || type == Number) {
				if (value > max) {
					return `El número debe ser menor o igual a: ${max}.`;
				}
			}

			if (type === 'text' || type === String) {
				if (value.length > max) {
					return `Maximo ${max} caracteres.`;
				}
			}

			if (type === Array) {
				if (value.length > max) {
					return `Las posiciones para esta colección, deben ser menores a ${max}`
				}
			}
		}

		return true;
	},	
};
